export const size = {
  xxl: { 'font-size': '2.25rem', 'line-height': '2.75rem' },
  xl: { 'font-size': '1.5rem', 'line-height': '2.125rem' },
  lg: { 'font-size': '1.25rem', 'line-height': '2rem' },
  md: { 'font-size': '1.125rem', 'line-height': '1.625rem' },
  sm: { 'font-size': '1rem', 'line-height': '1.5rem' },
  xs: { 'font-size': '0.875rem', 'line-height': '1.313rem' },
  xxs: { 'font-size': '0.75rem', 'line-height': '1.125rem' },
}
